import { entityIdAsString } from "../utilities/buildingLookup";

/**
 * Die Id einer Referenz, wenn man mit ihr navigieren kann — sonst `undefined`.
 *
 * Eine Referenz kommt als String, als ObjectId oder als Dokument. Fehlt die Id, stand bisher
 * `selectedEntity=undefined` in der Adresse, und die Seite meldete „Entity not found" ohne Weg
 * zurück (Etage → Sprung zum Gebäude). Die Zeichenketten "undefined" und "null" sind dieselbe
 * fehlende Id, nur schon einmal durch ein Template gelaufen.
 */
export function navigableEntityId(reference: unknown): string | undefined {
  const id = entityIdAsString(reference)?.trim();
  if (!id || id === "undefined" || id === "null" || id === "[object Object]") return undefined;
  return id;
}

/** Die Seite einer Entität — oder `undefined`, wenn die Referenz keine Id trägt. */
export function entityHref(type: string, reference: unknown): string | undefined {
  const id = navigableEntityId(reference);
  return id
    ? `/entity?selectedEntityType=${encodeURIComponent(type)}&selectedEntity=${encodeURIComponent(id)}`
    : undefined;
}

/** Ein Projekt in der Projektverwaltung, auf dem Reiter seiner Liegenschaften. */
export function projectHref(reference: unknown): string | undefined {
  const id = navigableEntityId(reference);
  return id
    ? `/settings?panel=projects&project=${encodeURIComponent(id)}&tab=objects`
    : undefined;
}
